import React, { useEffect } from 'react'
import { FloatingServiceMenu, Footer, Header, Page, PageTransition } from '@components/Page'
import { Container, Box, Heading, Text } from './gassan-ui'
import { useLocalization } from './Localization'
import ServiceSection from './ServiceSection'

interface Props {
  statusCode?: number | null
  hideMessage?: boolean
}

const ErrorPage: React.FC<Props> = ({ statusCode, hideMessage }) => {
  const { lang } = useLocalization()

  useEffect(() => {
    console.error(`Statuscode: ${statusCode}`)
  }, []) //eslint-disable-line

  return (
    <Page>
      <FloatingServiceMenu />
      <Header initialVariant="absolute" />
      <PageTransition>
        <Container
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          minHeight={300}
        >
          {!hideMessage && (
            <>
              <Box
                maxWidth={{ medium: '33rem', large: '43rem' }}
                textAlign="center"
                pt={{ _: '3rem', large: '8rem', xlarge: '11.5' }}
                pb={{ _: '3rem', large: '6rem', xlarge: '8.5' }}
              >
                <Heading as="h1" variant="h1" mb="1.5rem">
                  {lang === 'nl' ? 'Oeps, daar ging iets mis.' : 'Oops, something went wrong'}
                </Heading>
                <Text style={{ whiteSpace: 'pre-line' }}>
                  {statusCode === 404
                    ? lang === 'nl'
                      ? `De pagina die u probeert te bezoeken kon helaas niet worden gevonden. 
               Neem contact op met onze klantenservice als u hulp nodig heeft.`
                      : `Unfortunately, the page you are trying to visit could not be found. 
               Please contact our customer service if you need assistance.`
                    : lang === 'nl'
                    ? `Er ging iets mis. Herlaad de pagina en probeer het opnieuw. 
                Neem contact op met onze klantenservice als u hulp nodig heeft.`
                    : `Something went wrong. Reload the page and try again. 
                Please contact our customer service if you need assistance.`}
                </Text>
              </Box>
              <ServiceSection bg="white" />
            </>
          )}
        </Container>
        <Footer />
      </PageTransition>
    </Page>
  )
}

export default ErrorPage
